export default __webpack_public_path__ + "static/media/qr-code.34030017.svg";